import React from 'react';
import connect from "react-redux/es/connect/connect";
import { Link } from "react-router-dom";

import { List, Datagrid, FilterForm } from 'components/list';
import { TextField } from 'components/field';
import { TextInput } from 'components/input';

import { SORT_ASC } from "reducers/resource/list/queryReducer";
import FlatButton from "material-ui/FlatButton";
import linkToRecordByReplaceId from "util/linkToRecordByReplaceId";
import * as urls from './urls';
import * as utils from "./utils";


const AppSubscriptionFilter = (props) => (
  <FilterForm {...props} autoApplyFilterValue={true}>
    <TextInput label="Owner Mobile" source="owner_mobile_number"/>
    <TextInput label="Shop ID" source="shop_id"/>
  </FilterForm>
);

const CustomTextField = (props) => {
  const { record } = props;
  record.subscription_required_val = 'X';
  record.subscription_price = '-';
  if (record && record.subscription_required) {
    record.subscription_required_val = '✓';
  }
  if(record.subscription_required_val === '✓') {
    if(record.price_type === 2) {
      record.subscription_price = 'Subscription for Sunmi Shops';
    } else if(record.price_type === 3) record.subscription_price = 'Subscription for Non-Sunmi Shops';
    else {
      if(record.is_sunmi_shop) record.subscription_price = 'Subscription for Sunmi Shops';
      else record.subscription_price = 'Subscription for Non-Sunmi Shops';
    }
  }
  return (
    <TextField 
      {...props}
    />
  )
};

const ExtendButton = ({ record }) => {
  if (
    record
    && record.subscription_required
  ) {
    return (
      <FlatButton
        primary
        label="Extend"
        containerElement={(
          <Link 
            to={{
              pathname:linkToRecordByReplaceId(urls.appSubscriptionExtendFrontendPath, record.id),
              price_type: record.price_type,
              is_sunmi_shop: record.is_sunmi_shop,
            }}
          />
        )}
      />
    );
  }
  return null;

};

const AdjustButton = ({ record }) => {
  if (
    record
    && record.subscription_required
  ) {
    return (
      <FlatButton
        primary
        label="Adjust"
        containerElement={(
          <Link 
            to={linkToRecordByReplaceId(urls.appSubscriptionAdjustFrontendPath, record.id)}
          />
        )}
      />
    );
  }
  return null;
};

const ChangeStatusButton = ({ record }) => (
  <FlatButton
    primary
    label={
      <span style={ { whiteSpace: 'nowrap' } }>Change Status</span>
    }
    containerElement={(
      <Link 
        to={linkToRecordByReplaceId(urls.appSubscriptionUpdateFrontendPath, record.id)}
      />
    )}
  />
);

function AppSubscriptionListBase(props) {
  const is_superuser = (localStorage.getItem('is_superuser') === 'true');

  // app_subscription_expiry_adjust is the permission code_name for Adjust App Subscription Exp
  const have_adjust_permission = (
    localStorage.getItem('user_permissions') 
    ? localStorage.getItem('user_permissions').includes('app_subscription_expiry_adjust')
    : false
  );
  const show_adjust = (is_superuser || have_adjust_permission);

  // edit_app_subscription is the permission code_name for Edit App Subscription
  const have_edit_permission = (
    localStorage.getItem('user_permissions') 
    ? localStorage.getItem('user_permissions').includes('edit_app_subscription')
    : false
  );
  const show_edit = (is_superuser || have_edit_permission);

  return (
    <List
      {...props}
      hasCreate={false}
      filters={<AppSubscriptionFilter/>}
      sort={{ field: 'shop_id', order: SORT_ASC}}
      autoLoadData={props.filterValues && Object.keys(props.filterValues).length > 0}
    >
      <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
        <TextField source="id" label="ID"/>
        <TextField source="shop_id" label="Shop ID"/>
        <TextField source="owner_mobile_number" label="Owner Mobile"/>
        <TextField source="shop_name" label="Shop Name"/>
        <CustomTextField source="subscription_required_val" label="SW Required"/>
        <CustomTextField source="subscription_price" label="Subscription Price"/>
        <TextField source="expiry_time" label="Expiry Date"/>
        <TextField source="overdue_status" label="Overdue Status"/>
        <ExtendButton/>
        {show_adjust && (
          <AdjustButton />
        )}
        {show_edit && (
          <ChangeStatusButton />
        )}
      </Datagrid>
    </List>
  );
}

export const AppSubscriptionList = connect(
  state => ({
    filterValues: state.admin.filter[utils.AppSubscriptionResourceName],
  })
)(AppSubscriptionListBase);



// WEBPACK FOOTER //
// ./src/routes/product/AppSubscriptionList.js